import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import type { LucideIcon } from "lucide-react";

interface PMEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  /** Replaces the icon's default muted grey — a dashboard card's accent (a
   *  `CHART_ACCENTS` tint, so it matches the analytics charts). */
  iconColor?: string;
}

export function PMEmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
  iconColor,
}: PMEmptyStateProps) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center px-8 py-16 text-center", className)}
    >
      <Icon
        className={cn("mb-4 h-12 w-12", !iconColor && "text-muted-foreground/40")}
        style={iconColor ? { color: iconColor } : undefined}
      />
      <h3 className="mb-1 text-sm font-medium">{title}</h3>
      {description && <p className="max-w-sm text-xs text-muted-foreground">{description}</p>}
      {actionLabel && onAction && (
        <Button size="sm" className="mt-4" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
